<app-google-onetap-login *ngIf="vars.isBrowser && router?.url?.match('stories|fundraiser') && !qParams?.mini_story && !router?.url?.match('lg')"></app-google-onetap-login>

<div>
  <router-outlet></router-outlet>
</div>

<div *ngIf="loadingRouteConfig" class="content-wrapper">
  <div class="l-placeholder">
    <div class="l-animated-background"></div>
  </div>
</div>
